class SearchResultTranslator {
  translateResults (results, searchType) {
    var translatedResults = [];
    if ((results || null) === null) return translatedResults;

    for (var i = 0; i < results.length; i++) {
      var result = results[i];

      var translated = this.translateResult(result, searchType);
      if ((translated || null) === null) {
        continue;
      }

      translatedResults.push(translated);
    }

    translatedResults.sort((a, b) => {
      return a.sortValue < b.sortValue
        ? -1
        : (a.sortValue > b.sortValue ? 1 : 0);
    });
    return translatedResults;
  }

  translateResult (result, searchType) {
    var translated = {
      clientId: result.A,
      officeId: result.B,
      address: result.C,
      businessName: result.D,
      permissions: result.F,
      clientType: result.G,
      isArchived: result.H,
      fileTimestamp: result.I,
      customClientId: result.J,
      csr: result.K,
      producer: result.L,
      primaryEmail: result.M,
      primaryPhone: result.N,
      restricted: result.O,
      dba: result.P
    };

    if ((result.E || null) !== null) {
      translated.mainContact = this.translateMainContact(result.E);
    }

    if ((result.Y || null) !== null) {
      translated.summaryMatch = this.translateSummaryMatches(result.Y);
    }

    if ((result.Z || null) !== null) {
      translated.searchMatch = this.translateSearchMatches(result.Z);
    }

    translated.sortValue = this.getSortValue(translated, searchType);
    return translated;
  }

  translateMainContact (mainContact) {
    return {
      formattedName: this.formatName(mainContact.F, mainContact.L, mainContact.S),
      firstName: mainContact.F,
      lastName: mainContact.L,
      suffix: mainContact.S
    };
  }

  translateSearchMatches (searchMatches) {
    var translated = [];
    for (var i = 0; i < searchMatches.length; i++) {
      var toTranslate = searchMatches[i];

      translated.push({
        parentType: toTranslate.A,
        parentId: toTranslate.B,
        field: toTranslate.C,
        search: toTranslate.D
      });
    }

    return translated;
  }

  translateSummaryMatches (summaryMatches) {
    var translated = [];
    for (var i = 0; i < summaryMatches.length; i++) {
      var toTranslate = summaryMatches[i];

      translated.push({
        summaryType: toTranslate.A,
        summaryId: toTranslate.B,
        personalProfile: this.translateProfileSummary(toTranslate.C),
        personalProfileDriver: this.translateDriverSummary(toTranslate.D),
        policy: this.translatePolicySummary(toTranslate.E)
      });
    }

    return translated;
  }

  translateProfileSummary (profileSummary) {
    if ((profileSummary || null) === null) {
      return null;
    }

    return {
      formattedName: this.formatName(profileSummary.A, profileSummary.C, profileSummary.D),
      firstName: profileSummary.A,
      middleName: profileSummary.B,
      lastName: profileSummary.C,
      suffix: profileSummary.D,
      relationship: profileSummary.E,
      namedInsuredOrMainContactType: profileSummary.F
    };
  }

  translateDriverSummary (driverSummary) {
    if ((driverSummary || null) === null) {
      return null;
    }

    return {
      formattedName: this.formatName(driverSummary.C, driverSummary.D, driverSummary.F),
      firstName: driverSummary.C,
      lastName: driverSummary.D,
      state: driverSummary.E,
      suffix: driverSummary.F,
      relationship: driverSummary.G,
      namedInsuredOrMainContactType: driverSummary.H
    };
  }

  translatePolicySummary (policySummary) {
    if ((policySummary || null) === null) {
      return null;
    }

    return {
      policyNumber: policySummary.A,
      status: policySummary.B,
      officeId: policySummary.C,
      isArchived: policySummary.D,
      effectiveDate: policySummary.E,
      expirationDate: policySummary.F,
      carrier: policySummary.G,
      title: policySummary.H,
      displayOrder: policySummary.I,
      statusDate: policySummary.J
    };
  }

  getSortValue (result, searchType) {
    if ((result.businessName || null) !== null) return result.businessName;

    if ([2, 4, 5].includes(searchType)) {
      for (const match of result.summaryMatch) {
        // if the match was on a personal profile and if the personal profile is a named insured or main contact (0 === none), display that info
        if (match.summaryType === 2 && match.personalProfile.namedInsuredOrMainContactType !== 0) {
          return match.personalProfile.formattedName;
        }
      }
    }

    // othewise just display the main contact info
    return result.mainContact.formattedName;
  }

  formatName (firstName, lastName, suffix) {
    var name = '';
    if ((lastName || null) !== null && lastName !== '') {
      name += lastName;
    }

    if ((firstName || null) !== null && firstName !== '') {
      if (name !== '') name += `, ${firstName}`;
      else name = firstName;
    }

    if ((suffix || null) !== null && suffix !== '') {
      if (name !== '') name += `, ${suffix}`;
      else name = suffix;
    }

    return name;
  }
}

var x = new SearchResultTranslator();
export default x;
